import styled from "@emotion/styled";
import { Container, Grid, Typography } from "@mui/material";

const TokenContainer = styled(Container)`
    background-color:#000000;
    padding-top:100px;
    padding-bottom:100px;
    display:flex;
    justify-content:center;
    @media (max-width: 1024px){
        padding-top:60px;
        padding-bottom:60px;
    }
`
const ContentWrapper =styled(Grid)`

`

const Heading = styled(Typography)`
    color:#fff;
    font-size:80px;
    font-family:Oswald-bold;
    text-align:center;
    @media (max-width: 900px){
        font-size:40px;
    }
`
const HeadingGrid = styled(Grid)`
    margin-bottom:40px;
`
const DetailGrid = styled(Grid)`
    padding-left:8px !important;
    padding-right:8px !important;
    margin:15px 0px;
`
const BuyWrapper = styled.div`
    background-color:#141414;
    display:flex;
    align-items:center;
    border-radius:43px;
    padding:20px 30px;
    @media (max-width: 600px){
        display:block;
        padding:15px;
    }
`
const ImageWrapper = styled.div`
`
const BuyImg = styled.img`
    @media (max-width: 600px){
        width:80px;
        height:auto;
        max-width:100%;
    }

`
const BuyHeading = styled(Typography)`
    color:#C42927;
    font-family:Oswald-semibold;
    font-size:22px;
    @media (max-width: 600px){
        font-size:20px;
        margin-top:10px;
    }
`
const Desc = styled.p`
    color:#fff;
    font-family:poppins;
    font-size:14px;
    @media (max-width: 600px){
        font-size:12px;
    }
`
const TextWrapper = styled.div`
    display:flex;
    margin-left:20px;
    justify-content:center;
    flex-direction:column;
    @media (max-width: 600px){
        margin-left:0px;
    }
`
function HowToBuy(){
    return(
        <TokenContainer maxWidth="xxl" id="buy">
            <ContentWrapper container item xs={12} sm={12} md={12} lg={12} xl={8}>
                <HeadingGrid item xs={12}>
                    <Heading variant="h1">How To Buy</Heading>
                </HeadingGrid>
                <DetailGrid item xs={12}>
                    <BuyWrapper>
                        <ImageWrapper>
                            <BuyImg src="./assets/wallet.png" alt=""/>
                        </ImageWrapper>
                        <TextWrapper>
                            <BuyHeading>Create A Wallet</BuyHeading>
                            <Desc>Lorem ipsum dolor sit amet, consetetur sadipscing elitr, 
                                sed diam nonumy eirmod tempor invidunt ut labore et dolore
                                 magna aliquyam erat, sed diam voluptua.
                            </Desc>
                        </TextWrapper>
                    </BuyWrapper>
                </DetailGrid>
                <DetailGrid item xs={12}>
                    <BuyWrapper>
                        <ImageWrapper>
                            <BuyImg src="./assets/Eth.png" alt=""/>
                        </ImageWrapper>
                        <TextWrapper>
                            <BuyHeading>Get Some ETH</BuyHeading>
                            <Desc>Lorem ipsum dolor sit amet, consetetur sadipscing elitr, 
                                sed diam nonumy eirmod tempor invidunt ut labore et dolore
                                 magna aliquyam erat, sed diam voluptua.
                            </Desc>
                        </TextWrapper>
                    </BuyWrapper>
                </DetailGrid>
                <DetailGrid item xs={12}>
                    <BuyWrapper>
                        <ImageWrapper>
                            <BuyImg src="./assets/Uni.png" alt=""/>
                        </ImageWrapper>
                        <TextWrapper>
                            <BuyHeading>Go To Uniswap</BuyHeading>
                            <Desc>Lorem ipsum dolor sit amet, consetetur sadipscing elitr, 
                                sed diam nonumy eirmod tempor invidunt ut labore et dolore
                                 magna aliquyam erat, sed diam voluptua.
                            </Desc>
                        </TextWrapper>
                    </BuyWrapper>
                </DetailGrid>
                <DetailGrid item xs={12}>
                    <BuyWrapper>
                        <ImageWrapper>
                            <BuyImg src="./assets/5years.png" alt=""/>
                        </ImageWrapper>
                        <TextWrapper>
                            <BuyHeading>Swap ETH For $GEAR5</BuyHeading>
                            <Desc>Lorem ipsum dolor sit amet, consetetur sadipscing elitr, 
                                sed diam nonumy eirmod tempor invidunt ut labore et dolore
                                 magna aliquyam erat, sed diam voluptua.
                            </Desc>
                        </TextWrapper>
                    </BuyWrapper>
                </DetailGrid>
            </ContentWrapper>
        </TokenContainer>
    );
}

export default HowToBuy;